import React from 'react';
import Section from '../../Section';
import HelpArticleLink from '../HelpArticleLink';
import InvoicesManager from './InvoicesManager';

function InvoicesManagerSection() {
    return (
        <Section
            title="Invoices"
            subtitle="Create and manage invoices for your customers."
            preview="Send invoices, record payments, track outstanding balances, and communicate with customers."
            id="invoices-manager"
        >
            <HelpArticleLink
                slug="invoices"
                label="Learn about invoices"
                variant="link"
            />
            <InvoicesManager />
        </Section>
    );
}

export default InvoicesManagerSection;
